import * as R from 'ramda';
import React from 'react';

import {translate} from 'iss/strings';
import {SelectableTable} from 'iss/widgets/SelectableTable';
import {Table} from 'iss/widgets/bootstrap/Table';

export function FormList({forms, selectable = false, compact = false, extraColumns = [], ...props}) {
  const TableComponent = selectable ? SelectableTable : Table;
  const columns = compact ? compactColumns : defaultColumns;
  return <TableComponent id="forms-list" data={forms}
    {...props}
    columns={extraColumns.length > 0 ? [...columns, ...extraColumns] : columns}
  />;
}

const defaultColumns = [
  {
    header: translate('domain.evaluationForm.name'),
    cellProps: {className: "form-name" },
    accessor: form => form.name
  }, {
    header: translate('domain.evaluationForm.description'),
    cellProps: {className: "form-description" },
    accessor: form => form.description
  }, {
    header: translate('domain.evaluationForm.gradingScaleName'),
    cellProps: {className: "form-scale-name" },
    accessor: form => R.isNil(form.gradingScale) ? '' : form.gradingScale.name
  },
];

const compactColumns = [
  {
    header: translate('domain.evaluationForm.name'),
    cellProps: {className: "form-name" },
    accessor: form => form.name
  }, {
    header: translate('domain.evaluationForm.description'),
    cellProps: {className: "form-description" },
    accessor: form => form.description
  },
];



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/FormList.jsx